import * as http from '../http'
import * as Types from './types'

export default class CampaignsGateway {
  getCampaignUnassignedEmails () {
    return http.GET(Types.CAMPAIGN_UNASSIGNED_EMAILS)
  }

  campaignAddEmail (query = {}) {
    return http.POST(Types.CAMPAIGN_ADD_EMAIL, query)
  }

  changeCampaignValidity (query = {}) {
    return http.POST(Types.CHANGE_CAMPAIGN_VALIDITY, query)
  }

  updateCurrentEmailTemplate (query = {}) {
    return http.POST(Types.UPDATE_CURRENT_EMAIL_TEMPLATE, query)
  }

  getCampaignIndividualEmails (params = {}) {
    return http.GET(Types.CAMPAIGN_INDIVIDUAL_EMAILS, params)
  }

  getCampaignActiveId () {
    return http.GET(Types.CAMPAIGN_ACTIVE_ID)
  }

  getCampaignList () {
    return http.GET(Types.CAMPAIGN_LIST)
  }

  getAllCampaignList () {
    return http.GET(Types.CAMPAIGN_LIST, { deleted: true })
  }

  getCampaignStatus (params = {}) {
    return http.GET(Types.CAMPAIGN_STATUS, params)
  }

  setCampaignDisabledFlag (query = {}) {
    return http.POST(Types.CAMPAIGN_DISABLED_FLAG, query)
  }

  getCampaignBulkEmails (params = {}) {
    return http.GET(Types.CAMPAIGN_BULK_EMAILS, params)
  }

  getCurrentEmailTemplate () {
    return http.GET(Types.GET_CURRENT_EMAIL_TEMPLATE)
  }

  getCampaignStatistics (params = {}) {
    return http.GET(Types.CAMPAIGN_STATISTICS, params)
  }

  getCurrentCampaign () {
    return http.GET(Types.CURRENT_CAMPAIGN_END_POINT)
  }

  sendEmailsCampaign (query = {}) {
    return http.POST(Types.SEND_EMAILS_CAMPAIGN_END_POINT, query)
  }

  closeCurrentCampaign (query = {}) {
    return http.POST(Types.CLOSE_CAMPAIGN_END_POINT, query)
  }

  resetCampaignCode (query = {}) {
    return http.POST(Types.RESET_CODE_END_POINT, query)
  }

  resetManyCampaignCodes (query = {}) {
    return http.POST(Types.RESET_CODE_MANY_END_POINT, query)
  }

  getActiveCampaign () {
    return http.GET(Types.ACTIVE_CAMPAIGN_END_POINT)
  }

  getEmailTemplates () {
    return http.GET(Types.GET_EMAIL_TEMPLATES)
  }

  getEmailTemplate (params = {}) {
    return http.GET(Types.GET_EMAIL_TEMPLATE)
  }

  createEmailTemplate (query = {}) {
    return http.POST(Types.CREATE_EMAIL_TEMPLATE, query)
  }

  deleteCampaignCode (query = {}) {
    return http.DELETE(Types.DELETE_CODE_END_POINT, {}, query)
  }

  deleteEmailTemplate (query = {}) {
    return http.DELETE(Types.DELETE_EMAIL_TEMPLATE, {}, query)
  }

  deleteManyCampaignCodes (query = {}) {
    return http.DELETE(Types.DELETE_CODE_MANY_END_POINT, {}, query)
  }

  createCampaign (query = {}) {
    return http.POST(Types.CREATE_CAMPAIGN_END_POINT, query)
  }
}



// WEBPACK FOOTER //
// ./src/api/campaigns/CampaignsGateway.js